export const getTokenFromURL = () => {
    const parts = window.location.pathname.split('/');
    const token = parts[parts.length - 1];

    return token;
}